import { render, staticRenderFns } from "./ResolDeltaSolSlt_1d05.vue?vue&type=template&id=2385f482&"
import script from "./ResolDeltaSolSlt_1d05.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolSlt_1d05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports